import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { bubEvents } from 'javascripts/shared/events/bub_events';
import { useClickOutside } from 'javascripts/hooks/use-click-outside';

import { ChirpButton } from 'javascripts/components/chirp_button';

import dotMenu from 'images/dot_menu.svg';

import styles from 'stylesheets/components/secondary_menu.module';

export function SecondaryMenu(props) {
  const [secondaryMenuHidden, setSecondaryMenuHidden] = useState(true);
  const ref = useClickOutside(() => {
    setSecondaryMenuHidden(true);
  });

  function onSecondaryOptionSelect(option) {
    bubEvents.track(props.trackingCategory, props.trackingAction, {
      label: 'Option selected',
      value: option.label,
      ...props.trackingProps,
    });

    option.action();
    setSecondaryMenuHidden(true);
  }

  function renderSecondaryOptions() {
    return props.options.map(option => (
      <button
        key={option.label.replace(/\s+/g, '-').toLowerCase()}
        className={styles.secondaryMenuItem}
        onClick={() => onSecondaryOptionSelect(option)}
        aria-label={option.label}
      >
        {option.label}
      </button>
    ));
  }

  return (
    <div className={styles.secondaryMenuButton} ref={ref}>
      <ChirpButton
        displayType='link'
        icon={dotMenu}
        iconAltText='Secondary actions menu'
        iconSize={props.iconSize}
        onClick={() => {
          setSecondaryMenuHidden(!secondaryMenuHidden);
        }}
      />
      <div
        className={classNames(styles.secondaryMenuDropdown, { [styles.secondaryMenuHidden]: secondaryMenuHidden })}
        aria-hidden={secondaryMenuHidden}
      >
        {renderSecondaryOptions()}
      </div>
    </div>
  );
}

SecondaryMenu.propTypes = {
  iconSize: PropTypes.oneOf(['small', 'medium', 'large', 'extraLarge']),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      action: PropTypes.func.isRequired,
    }),
  ).isRequired,
  trackingCategory: PropTypes.string.isRequired,
  trackingAction: PropTypes.string,
  trackingProps: PropTypes.object,
};

SecondaryMenu.defaultProps = {
  iconSize: 'small',
};
